module.exports = __webpack_public_path__ + "img/pause-at.4aedc3e8.svg";